module.exports = __webpack_public_path__ + "static/media/Karanja Gichiri.c3c1252e.jpg";